import { AsarFormikInput, Loader } from "@/components";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import { changePhone } from "../../../api/user";
import { getTokenUser, setToken } from "@/api/token";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CheckPhone from "./CheckPhone";

export default function ChangePhoneNum({ open, setOpen }) {
  const [dataCheckCode, setDataCheckCode] = useState();
  const [showCheckPhone, setShowCheckPhone] = useState(false);
  const navigate = useNavigate();

  const onChangePhone = async (values, actions) => {
    changePhone(values)
      .then((x) => {
        setDataCheckCode({ token: x.token });
        setShowCheckPhone(true);
      })
      .catch(() => {})
      .finally(() => actions.setSubmitting(false));
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogTitle>{"تغییر شماره تلفن همراه"}</DialogTitle>
        <DialogContent>
          {showCheckPhone ? (
            <CheckPhone
              setDataCheckCode={setDataCheckCode}
              dataCheckCode={dataCheckCode}
              setShow={setShowCheckPhone}
              changeCallback={() => {
                toast(
                  "تغییر شماره همراه شما با موفقیت تغییر یافت. لطفا مجدد ورود فرمایید",
                );
                setOpen(false);
                setTimeout(() => {
                  if (getTokenUser()) {
                    const token = getTokenUser();
                    localStorage.clear();
                    setToken(token);
                    navigate("/");
                    window.location.reload();
                  } else {
                    localStorage.clear();
                    navigate("/login");
                  }
                }, 500);
              }}
            />
          ) : (
            <>
              <DialogContentText>
                کاربر گرامی، شماره تلفن همراه مورد نظر خود را وارد کنید.
              </DialogContentText>

              <Formik
                initialValues={{
                  newPhone: "",
                }}
                // validationSchema={}
                onSubmit={onChangePhone}
                validateOnBlur={false}
                validateOnChange={false}
              >
                {({ isSubmitting, submitForm }) => (
                  <Form
                    style={{
                      marginTop: "30px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      gap: "20px",
                    }}
                  >
                    <AsarFormikInput
                      maxLength={11}
                      inputMode="numeric"
                      name="newPhone"
                      label="تلفن همراه جدید"
                      placeholder="تلفن همراه جدید خود را وارد کنید."
                    />

                    {isSubmitting && <Loader />}
                    {!isSubmitting && (
                      <Button onClick={submitForm} variant="contained">
                        {"ویرایش تلفن همراه"}
                      </Button>
                    )}
                  </Form>
                )}
              </Formik>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
